import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolbarTranslate = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.5 12L6.5 2H7.5L7.5 12H6.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 6.5L12 6.5V7.5L2 7.5V6.5Z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M7 0L8.73205 3H5.26795L7 0Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 7L11 8.73205V5.26795L14 7Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 14L5.26795 11H8.73205L7 14Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M0 7L3 5.26795L3 8.73205L0 7Z" })
	]
});
export default SvgToolbarTranslate;
